import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config';

function SetRateModal({ onClose, onSuccess, delivery }) {
  const [rate, setRate] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/set-delivery-rate`, {
        deliveryId: delivery.id,
        rate: parseFloat(rate)
      });
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error setting rate: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Set Delivery Rate</h2>
        <p>Customer: {delivery.customer?.name}</p>
        <p>Quantity: {delivery.quantity} kg</p>
        <form onSubmit={handleSubmit}>
          <input type="number" step="0.01" placeholder="Rate per kg" value={rate} onChange={(e) => setRate(e.target.value)} required autoFocus />
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>{loading ? 'Saving...' : 'Set Rate'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SetRateModal;